var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToyota(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_397",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29009",
    "data-name": "Group 29009",
    transform: "translate(-3672 4996)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3672, -4996)",
    filter: "url(#Ellipse_397)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_397-2",
    "data-name": "Ellipse 397",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-toyota",
    transform: "translate(3688 -4985)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50586",
    "data-name": "Path 50586",
    d: "M21,9C9.954,9,1,14.84,1,22.043S9.954,35.087,21,35.087s20-5.84,20-13.043S32.046,9,21,9Zm0,23.478c-9.124,0-16.522-4.672-16.522-10.435S11.876,11.609,21,11.609s16.522,4.672,16.522,10.435S30.124,32.478,21,32.478Z",
    fill: "#b3bde2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50587",
    "data-name": "Path 50587",
    d: "M23.217,12C20.336,12,18,16.672,18,22.435S20.336,32.87,23.217,32.87s5.217-4.672,5.217-10.435S26.1,12,23.217,12Zm0,17.391c-1.441,0-2.609-3.115-2.609-6.957s1.168-6.957,2.609-6.957,2.609,3.115,2.609,6.957S24.658,29.391,23.217,29.391Z",
    transform: "translate(-2.217 -0.391)",
    fill: "#b3bde2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50588",
    "data-name": "Path 50588",
    d: "M21,22.73c0-.011,0-.023,0-.034,0-3.842,1.168-6.957,2.609-6.957s2.609,3.115,2.609,6.957c0,.077,0,.153,0,.23h.009C26.24,17.88,25.673,14,23.608,14c-2.174,0-2.618,4-2.615,8.73Z",
    transform: "translate(-2.608 -0.652)",
    fill: "#7986cb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50589",
    "data-name": "Path 50589",
    d: "M21.913,10C14.229,10,8,12.725,8,16.087s6.229,6.087,13.913,6.087,13.913-2.725,13.913-6.087S29.6,10,21.913,10Zm0,9.565c-5.763,0-10.435-1.97-10.435-4.13s4.672-3.7,10.435-3.7,10.435,1.535,10.435,3.7S27.676,19.565,21.913,19.565Z",
    transform: "translate(-0.913 -0.13)",
    fill: "#b3bde2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50590",
    "data-name": "Path 50590",
    d: "M4.739,22.855A7.939,7.939,0,0,1,7.4,17.192a2.783,2.783,0,0,1-.049-.423,3,3,0,0,1,.47-1.546C4.744,16.988,3,19.557,3,22.855,3,29.1,11.222,32.2,17.727,33.045,10.3,32.022,4.739,27.851,4.739,22.855ZM34.7,15.222a3,3,0,0,1,.47,1.546,2.783,2.783,0,0,1-.049.423,7.939,7.939,0,0,1,2.657,5.663c0,5-5.563,9.167-12.988,10.19C31.3,32.2,39.522,29.1,39.522,22.855,39.522,19.557,37.777,16.988,34.7,15.222Z",
    transform: "translate(-0.261 -0.812)",
    fill: "#7986cb"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToyota);
export default __webpack_public_path__ + "static/media/toyota.61aa0db387bceb801f94fcb5c90e57d9.svg";
export { ForwardRef as ReactComponent };